<div class="wrapper-lg">
    <app-breadcrumbs [items]="[{ url: '/health-ministry-dashboard', text: 'healthMinistryDashboard_title' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'healthMinistryDashboard_title' | translate}}</h1>
    </header>

    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabId" class="nav-tabs">
        <li [ngbNavItem]="1">
            <a ngbNavLink [routerLink]="['/health-ministry-dashboard'] | localize" [queryParams]="{ tab: 'residents' }">
                {{'healthMinistryDashboard_residents' | translate}}
            </a>
            <ng-template ngbNavContent>
                <div class="mt-3">
                    <app-health-ministry-dashboard-residents *ngIf="residents"
                                                             [data]="residents"
                                                             [filters]="filters"></app-health-ministry-dashboard-residents>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="2">
            <a ngbNavLink [routerLink]="['/health-ministry-dashboard'] | localize" [queryParams]="{ tab: 'stats' }">
                {{'healthMinistryDashboard_stats' | translate}}
            </a>
            <ng-template ngbNavContent>
                <app-health-ministry-dashboard-stats *ngIf="residents"
                                                     [data]="residents"
                                                     [filters]="filters"></app-health-ministry-dashboard-stats>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>
